// extracted by mini-css-extract-plugin
export default {"container":"LMgB","blockHeader":"f5cE","rangesWrapper":"C9Lk","rangeWrapper":"Ute4","range":"chpk","remove":"R5TU","actions":"Vhxp","btn":"ZBKe"};